import axios from "./config";
const userService = {};
const commonService = {};
const dashboardService = {};

const clear = (value)=>{
   if(value==null){
     return ''
   }else{
    return value
   }
}


userService.login = (username, password) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.post['Content-Type'] = 'application/json';
    axios
      .post('/login', {
        username: username,
        password: password,
      })
      .then(({ data }) => {
        resolve(data);
      })
      .catch(error => {
        reject(error)
      });
  });
}

userService.me = () => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .get('/me')
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  });
}

userService.logout = () => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .post('auth/logout')
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  });
}


userService.reset_password = (data) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .post('/password-forgotten', data)
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  });
}

userService.change_password = (password) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .post('/password_change', {
        password: password,
      })
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  });
}

userService.validate_customer = (card_number) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .post('/card/validate/' + card_number)
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  });
}

userService.validate_appointment = (appointmentId, pin) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .post('/sheduled-appointments/validate', {
        appointment_booking_id: appointmentId,
        pin: pin,

      })
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  });
}

userService.confirm_appointment = (id) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .post('/sheduled-appointments/confirm', {
        appointment_booking_id: id,
      })
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  });
}

userService.card_data = (card_number) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .get('/card/details/' + card_number)
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  });
}

commonService.getSubjects = (cardNumber, filter_path = '') => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .get('/subjects/' + cardNumber + '?filter_path=' + filter_path)
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  });
}

commonService.createVoucherAppointment = (data) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .post('/sheduled-appointments', data)
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  });
}


commonService.usageList = (pagination, sorting, tst = '', location = '', cardNumber = '', validationStatus = '', name = '',dateStart='',dateEnd='') => {
  console.log(cardNumber);
  const url = "validatons?"
    + 'start=' + pagination.pageIndex * pagination.pageSize
    + '&limit=' + pagination.pageSize
    + '&filter_location=' + location
    + '&filter_status=' + validationStatus
    + '&filter_name=' + name
    + '&filter_card=' + cardNumber
    + '&filter_date_start=' + clear(dateStart)
    + '&filter_date_end=' + clear(dateEnd);

  console.log(url);
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .get(url)
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  });
}

commonService.schedules = (pagination, sorting, tst = '', location = '', cardNumber = '', voucher = '',dateStart='',dateEnd='',name='') => {
  const url = "schedules?"
    + 'start=' + pagination.pageIndex * pagination.pageSize
    + '&limit=' + pagination.pageSize
    + '&filter_location=' + location
    + '&filter_card=' + cardNumber
    + '&filter_voucher=' + voucher
    + '&filter_date_start=' + clear(dateStart)
    + '&filter_date_end=' + clear(dateEnd)
    + '&filter_name=' + clear(name);


  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .get(url)
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  });
}


commonService.uploadDocument = (data) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('token');
    axios
      .post('upload-document/', data
        , {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      .then(({ data }) => {
        resolve(data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

commonService.getDocuments = () => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .get('/documents')
      .then(({ data }) => { resolve(data.data) })
      .catch(error => { reject(error) });
  });
}

commonService.getActs = (pagination, sorting, tst = '', location = '') => {
  const url = "acts?"
    + 'start=' + pagination.pageIndex * pagination.pageSize
    + '&limit=' + pagination.pageSize
    + '&filter_location=' + location

  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .get(url)
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  });
}

commonService.getFinishedActs = (location = '') => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .get('/finished-acts?filter_location' + location)
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  });
}
commonService.getYearMonths = () => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .get('/current-account/months')
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  });
}

commonService.getCurrentAccount = (locationId,dateStart='',dateEnd='') => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .get('/current-account/'+locationId+'?date_start='+dateStart+'&date_end='+dateEnd)
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  });
}

commonService.esquebras = () => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .get('/esquebras')
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  });
}


commonService.esquebrasById = (id) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .get('/esquebras/' + id)
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  });
}


commonService.esquebraUsages = () => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .get('/esquebras/usages')
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  });
}

userService.validate_esquebra = (esquebraId, pin) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .post('/esquebraUsageValidate/' + esquebraId + '/validate', {
        esquebrea_id: esquebraId,
        pin: pin,
      })
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  });
}

dashboardService.getValidations = (locationId) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .get('/dashboard/validations?filter_location='+locationId)
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  })
}
dashboardService.nextAppointments = (locationId) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .get('/dashboard/appointments/future?filter_location='+locationId, )
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  })
}
dashboardService.getActsStats = (locationId) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .get('/dashboard/acts-stats?filter_location='+locationId, )
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  })
}

dashboardService.getCurrentAccountStats = (locationId) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .get('/dashboard/current-account?filter_location='+locationId, )
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  })
}

dashboardService.getCurrentAccountMovements = (locationId) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('provider_token');
    axios.defaults.headers.common['x-provider-key'] = token;
    axios
      .get('/dashboard/movements?filter_location='+locationId, )
      .then(({ data }) => { resolve(data) })
      .catch(error => { reject(error) });
  })
}

export {
  userService,
  commonService,
  dashboardService
};

//Product service